<template>
  <ImportExport :title="$t('keywords.sequences')" type="sequence" :headers="headers" v-on="$listeners">
    <template #item.identifier="{ item }">
      <v-text-field v-model="item.key.identifier" style="margin-bottom: -2.3vh" outlined dense :rules="alphaNumericRules(item.key.identifier)" />
    </template>

    <template #item.value="{ item }">
      <v-text-field
        :rules="requiredRules(item.value)"
        v-model="item.value"
        type="number"
        min="0"
        step="1"
        style="margin-bottom: -2.3vh" outlined dense
      />
    </template>
  </ImportExport>
</template>

<script>
import ImportExport from '../core/ImportExport.vue'
import { alphaNumericRules, requiredRules } from '../../utils/rules'

export default {

  components: { ImportExport },

  data: () => ({
    alphaNumericRules,
    requiredRules
  }),

  computed: {
    headers () {
      return [
        {
          text: this.$t('sequence.name'),
          value: 'identifier'
        },
        {
          text: this.$t('parameter.param.description'),
          value: 'value'
        }
      ]
    }
  }

}
</script>
